module.exports = __webpack_public_path__ + "img/icon_kcmn.d65596ef.png";